const Terms = () => (
    <div>
        <h2>LeasePoint Funding Group Payment Portal Terms</h2>
        These Payment Terms and Disclosures ("Terms") govern your use of the LeasePoint Funding Group payment portal to
        make payments towards your account. By using the portal, you agree to these Terms.
        <h2>1. Payment Options and Recurring Payments</h2>
        Our payment portal allows for both one-time and recurring payments. You can choose to schedule recurring
        payments to ensure your account remains current. We will securely store your payment profile information to
        facilitate these recurring payments and any other charges we may need to make to your account, as outlined
        below.
        <h2>2. Account Maintenance and Payment Authorization</h2>
        By creating a payment profile and using our portal, you authorize LeasePoint Funding Group to store your payment
        information securely. This authorization allows us to:
        <ul>
            <li>Process your initial payment and any future recurring payments you establish.</li>
            <li>
                Charge your designated payment method for any additional charges necessary to keep your account current,
                including scheduled fees or outstanding balances.
            </li>
        </ul>
        <h2>3. Accepted Payment Methods</h2>
        We accept credit card, ACH transfer, and debit card payments through our secure payment portal powered by
        Authorize.Net. We utilize ACHQ, a separate Authorize.Net service, to facilitate ACH transactions. Our funds are
        ultimately deposited with JPMorgan Chase.
        <h2>4. Payment Processing</h2>
        We utilize Authorize.Net, a reputable third-party payment processor, to securely process your credit card and
        debit card transactions. ACH transactions are facilitated through ACHQ, a separate Authorize.Net service. Our
        funds are deposited into our account with JPMorgan Chase. Please refer to Authorize.Net's terms of service for
        additional information about their services.
        <br />
        <br />
        <strong>AUTHORIZATION FOR ACH OR CREDIT CARD PAYMENTS:</strong>
        Debtor authorizes Creditor (LeasePoint Funding Group, LLC), Creditor’s successors and assigns (Equipsure, LLC
        and/or Others as designated by LeasePoint) to automatically initiate and make debit entry charges to Debtor’s
        bank account or credit card from which the Debtor paid any deposit or fee in conjunction with the execution of
        this EFA (herein, as applicable, referred to as “Account”), or any Account from which Debtor paid any obligation
        under this EFA, or any Account shown on any bank statement provided, or the Account from which a canceled or
        voided check provided by the Debtor can be drawn, for the payment of all amounts owed by Debtor from time to
        time under the EFA. This authorization is to remain in effect during the term of the EFA. Any incorrect charge
        will be corrected upon notification to Creditor, by either a credit or debit to Debtor’s Account.
        <h2>5. Credit Card Payments</h2>
        <ul>
            <li>
                <strong>Chargebacks:</strong> You have the right to initiate a chargeback for unauthorized or disputed
                transactions. Our policies regarding chargebacks will be followed, and we reserve the right to dispute
                any chargebacks we believe to be invalid. Please refer to the relevant credit card network's rules
                (e.g., Visa, Mastercard) for additional information on chargebacks.
            </li>
            <li>
                <strong>Surcharges:</strong> We currently do not add any surcharges to cover credit card processing
                fees. This policy is subject to change, and we will provide notification if any surcharges are
                implemented in the future.
            </li>
        </ul>
        <h1>6. ACH Payments</h1>
        <ul>
            <li>
                <strong>Returned Payments:</strong> In the event of a returned ACH payment due to insufficient funds,
                you may be subject to a returned payment fee and/or limitations on future use of ACH payments. The
                specific fees and limitations will be outlined in a separate communication in the event of a returned
                payment.
            </li>
            <li>
                <strong>Recurring Payments:</strong> Our ACH payment option is strictly for one-time transactions. We do
                not offer recurring ACH payments at this time.
            </li>
        </ul>
        <h2>7. Data Security</h2>
        LeasePoint Funding Group takes data security seriously. We maintain industry-standard security measures to
        protect your payment information.
        <h2>8. Privacy Policy</h2>
        Please refer to our separate Privacy Policy which details how we collect, use, and store your data. You can
        access our Privacy Policy by clicking{' '}
        <a href="https://www.leasepointfg.com/privacy-policy/" target={'_blank'} rel="noreferrer">
            https://www.leasepointfg.com/privacy-policy/
        </a>
        .<h2>9. Disclaimer</h2>
        These Terms are intended for informational purposes only and do not constitute legal advice. For specific legal
        guidance, please consult with an attorney.
        <h2>10. Governing Law</h2>
        These Terms shall be governed by and construed in accordance with the laws of the State of Texas.
        <h2>11. Contact Us</h2>
        If you have any questions regarding these Terms, please contact us at: <br />
        <br />
        LeasePoint Funding Group <br />
        6548 Comanche Trail, Suite 301 <br />
        Austin, TX 78732 <br />
        (855) 553-2735 <br />
        help@leasepointFG.com
    </div>
);

export default Terms;
